import React, { useState } from "react";
import Main from "./components/Main/MainContainer";
import PasswordValidator from "./components/Password";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const password = "4711";

  const handleLogin = (passwordAttempt) => {
    if (passwordAttempt === password) setIsLoggedIn(true);
  };
  return (
    <div className="App">
      {isLoggedIn ? <Main /> : <PasswordValidator handleLogin={handleLogin} />}
    </div>
  );
}

export default App;
